var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2808 20.0136C25.3572 20.091 25.4306 20.1653 25.5003 20.2373C25.8485 20.597 26.0029 21.0283 26 21.45C25.9942 22.3661 25.2467 23.2375 24.137 23.2375H1.86298C0.753341 23.2375 0.00642403 22.3661 4.01251e-05 21.45C-0.00286165 21.0283 0.151513 20.5976 0.499726 20.2373C0.569369 20.1653 0.64278 20.091 0.719223 20.0136C1.8735 18.8456 3.71896 16.9782 3.71896 11.6187C3.71896 7.27848 6.88073 3.80402 11.144 2.95161V1.7875C11.144 0.800465 11.9751 0 13 0C14.0249 0 14.856 0.800465 14.856 1.7875V2.95161C19.1193 3.80402 22.281 7.27848 22.281 11.6187C22.281 16.9782 24.1265 18.8456 25.2808 20.0136ZM16.7125 25.025C16.7125 26.9996 15.0498 28.6 13 28.6C10.9502 28.6 9.28745 26.9996 9.28745 25.025H16.7125Z",
    fill: "#0059A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.9fbfb6ab5aeefc75d8f9be05c6b1ff68.svg";
export { ForwardRef as ReactComponent };